/***
 *
 *   EMPTY STATE
 *   Use when there is no data to display. Ported from
 *   ui-reference/src/components/ui/empty-state.tsx.
 *
 *   Exported as both `EmptyState` (the reference's name, preferred) and
 *   `BlankSlateMessage` (this app's existing name, kept for its call sites).
 *
 *   PROPS
 *   title: descriptive string (optional)
 *   text / description: supporting copy (optional)
 *   icon: feather icon name for the well (default: inbox)
 *   action: callback executed on button click (optional)
 *   buttonText: cta button text
 *   bare: drop the dashed frame when the parent already has one
 *
 **********/

import { Button, Icon, ClassHelper } from 'components/lib';
import Style from './blankslate.tailwind.js';

export function EmptyState(props) {
    const style = ClassHelper(Style, {
        bare: props.bare,
        className: props.className,
    });

    return (
        <div className={style}>
            <div className={Style.iconWell}>
                <Icon image={props.icon || 'inbox'} size={20} color="currentColor" />
            </div>

            {props.title && <h4 className={Style.title}>{props.title}</h4>}

            {(props.text || props.description) && <p className={Style.text}>{props.text || props.description}</p>}

            {(props.action || props.children) && (
                <div className={Style.action}>
                    {props.children ||
                        (props.buttonText && <Button text={props.buttonText} action={props.action} size="sm" />)}
                </div>
            )}
        </div>
    );
}

export const BlankSlateMessage = EmptyState;
